import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import status_en from './translations/en/status.json';
import legal_en from './translations/en/legal.json';
import common_en from './translations/en/common.json';
import driver_en from './translations/en/driver.json';
import static_en from './translations/en/static.json';
import eta_en from './translations/en/eta.json';

import status_ru from './translations/ru/status.json';
import legal_ru from './translations/ru/legal.json';
import common_ru from './translations/ru/common.json';
import driver_ru from './translations/ru/driver.json';
import static_ru from './translations/ru/static.json';
import eta_ru from './translations/ru/eta.json';

import status_he from './translations/he/status.json';
import legal_he from './translations/he/legal.json';
import common_he from './translations/he/common.json';
import driver_he from './translations/he/driver.json';
import static_he from './translations/he/static.json';
import eta_he from './translations/he/eta.json';

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    debug: true,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
        en: {
            status: status_en,
            legal: legal_en,
            common: common_en,
            driver: driver_en,
            static: static_en,
            eta: eta_en,
        },
        ru: {
            status: status_ru,
            legal: legal_ru,
            common: common_ru,
            driver: driver_ru,
            static: static_ru,
            eta: eta_ru,
        },
        he: {
            status: status_he,
            legal: legal_he,
            common: common_he,
            driver: driver_he,
            static: static_he,
            eta: eta_he,
        },
    },
});

export default i18n;
